import React, {useState} from 'react';
import * as yup from 'yup';
import {getLanguage, t} from 'react-switch-lang';
import {yupResolver} from '@hookform/resolvers';
import SelectInfinite from '../../components/FormFields/SelectInfinite';
import {FormProvider, useForm} from 'react-hook-form';
import DownloadBtn from './reportForm/components/downloadBtn/DownloadBtn';
import SelectList from '../../components/FormFields/select/SelectList';
import {assessmentResultsOptions, yesNoOptions} from '../../utils/externalizationFormOptions';
import InputDate from '../../components/FormFields/inputDate/InputDate';
import {format} from 'date-fns';
import {appModules} from '../../utils/const';
const ExternalizationsReport = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const lang = getLanguage();
  const schema = yup.object().shape({
  });
  const methods = useForm({
    resolver: yupResolver(schema)
  });

  const {watch, errors} = methods;
  const contractStartDateFrom = watch('contractStartDateFrom');
  const contractStartDateTo = watch('contractStartDateTo');
  const contractEndDateFrom = watch('contractEndDateFrom');
  const contractEndDateTo = watch('contractEndDateTo');
  const lastRiskAssessmentDateFrom = watch('lastRiskAssessmentDateFrom');
  const lastRiskAssessmentDateTo = watch('lastRiskAssessmentDateTo');

  const returnMultiSelectString=(options,apiParamAddon)=>{
    if (!options) return "";
    if (!Array.isArray(options)) {
      return `${apiParamAddon}=${options.value}`;
    }
    return options
      .map(opt => `${apiParamAddon}=${opt.value}`)
      .join('&');
  }

  return (
    <div className="revisions-reports-page content">
      <FormProvider {...methods}>
        <div className="report-form-container" key={window.location.pathname}>
          <div className="row  ml-0 mr-0">
            <div className="form-group pr-5 w-25">
            <label className="label w-100" htmlFor="departmentIds">
              {t("externalization.report.department")}
              <span className="optional register line-height">{t("common.optional")}</span>
            </label>
            <SelectInfinite
              api={`/departments?appModuleId.equals=${appModules?.externalizationModule}&active.equals=true`}
              name="departmentIds"
              labelKey={lang === "mne" ? "name" : "nameEn"}
              className="departmentIds"
              placeholder={t('incurred-risk.placeholder.department')}
              isMulti
            />
              <label className="label w-100 pt-4">{t('externalization.riskProponentForm.critical')}
              <span className="optional register line-height">{t("common.optional")}</span>
            </label>
              <SelectList
                name="critical"
                placeholder={t("externalization.riskProponentForm.placeholder.critical")}
                options={yesNoOptions}
              />
              <label className="label w-100 pt-4" htmlFor="serviceProviderIds">
                {t("externalization.riskProponentForm.serviceProvider")}
                <span className="optional register line-height">{t("common.optional")}</span>
              </label>
              <SelectInfinite
                api={`/service-providers`}
                name="serviceProviderIds"
                labelKey={lang === "mne" ? "name" : "nameEn"}
                className="serviceProviderIds"
                placeholder={t("externalization.riskProponentForm.placeholder.serviceProvider")}
                isMulti
              />
            </div>
            <div className="form-group pr-5 w-25">
            <label className="label w-100">   {t('externalization.report.contractValidityFrom')}
                <span className="optional register line-height">{t("common.optional")}</span>
              </label>
              <InputDate
                name="contractStartDateFrom"
                maxDate={contractStartDateTo}
                className={'date-input'}
                isClearable={true}
                placeholder={t('externalization.report.placeholder.contractValidityFrom')}
              />
              <label className="label w-100 pt-4">   {t('externalization.report.contractDurationFrom')}
                <span className="optional register line-height">{t("common.optional")}</span>
              </label>
              <InputDate
                name="contractEndDateFrom"
                maxDate={contractEndDateTo}
                className={'date-input'}
                isClearable={true}
                placeholder={t('externalization.report.placeholder.contractDurationFrom')}
              />
              <label className="label w-100 pt-4">   {t('externalization.report.processingDateReportFrom')}
                <span className="optional register line-height">{t("common.optional")}</span>
              </label>
              <InputDate
                name="lastRiskAssessmentDateFrom"
                maxDate={lastRiskAssessmentDateTo}
                className={'date-input'}
                isClearable={true}
                placeholder={t('externalization.report.placeholder.processingDateReportFrom')}
              />
            </div>
            <div className="form-group pr-5 w-25">
            <label className="label w-100">   {t('externalization.report.contractValidityTo')}
                <span className="optional register line-height">{t("common.optional")}</span>
              </label>
              <InputDate
                name="contractStartDateTo"
                minDate={contractStartDateFrom}
                className={'date-input'}
                isClearable={true}
                placeholder={t('externalization.report.placeholder.contractValidityTo')}
              />
              <label className="label w-100 pt-4">   {t('externalization.report.contractDurationTo')}
                <span className="optional register line-height">{t("common.optional")}</span>
              </label>
              <InputDate
                name="contractEndDateTo"
                minDate={contractEndDateFrom}
                className={'date-input'}
                isClearable={true}
                placeholder={t('externalization.report.placeholder.contractDurationTo')}
              />
              <label className="label w-100 pt-4">   {t('externalization.report.processingDateReportTo')}
                <span className="optional register line-height">{t("common.optional")}</span>
              </label>
              <InputDate
                name="lastRiskAssessmentDateTo"
                minDate={lastRiskAssessmentDateFrom}
                className={'date-input'}
                isClearable={true}
                placeholder={t('externalization.report.placeholder.processingDateReportTo')}
              />
            </div>
            <div className="form-group pr-5 w-25">
              <label className="label w-100 mt-2">{t('externalization.riskProponentForm.personalInfo')}
                <span className="optional register line-height">{t("common.optional")}</span>
              </label>
              <SelectList
                name="includesPersonalData"
                placeholder={t('externalization.riskProponentForm.placeholder.personalInfo')}
                options={yesNoOptions}
              />
              <label className="label w-100 pt-4">{t('externalization.riskProponentForm.resultOfRiskAssessment')}
              <span className="optional register line-height">{t("common.optional")}</span>
            </label>
              <SelectList
                name="assessmentResults"
                className="select"
                placeholder={t("externalization.riskProponentForm.placeholder.resultOfRiskAssessment")}
                options={assessmentResultsOptions}
                isMulti
              />
              <DownloadBtn
                api={'reports/externalization-registry'}
                isDisabled={Object.keys(errors)?.length !== 0}
                paramsLength={11}
                documentName={`PDF`}
                setIsSubmitted={(e) => setIsSubmitted(e)}
                disableCheckingIfAllFilled={true}
                apiParameters={{
                  departmentIds: returnMultiSelectString(
                    watch('departmentIds'),
                    'departmentIds'
                  ),
                  critical: returnMultiSelectString(
                    watch('critical'),
                    'critical'
                  ),
                  serviceProviderIds: returnMultiSelectString(
                    watch('serviceProviderIds'),
                    'serviceProviderIds'
                  ),
                  contractStartDateFrom:
                    contractStartDateFrom !== null && contractStartDateFrom !== undefined
                      ? `contractStartDateFrom=${encodeURIComponent(
                        format(contractStartDateFrom, 'yyyy-MM-dd')
                      )}`
                      : '',
                  contractStartDateTo:
                    contractStartDateTo !== null && contractStartDateTo !== undefined
                      ? `contractStartDateTo=${encodeURIComponent(
                        format(contractStartDateTo, 'yyyy-MM-dd')
                      )}`
                      : '',
                  contractEndDateFrom:
                    contractEndDateFrom !== null && contractEndDateFrom !== undefined
                      ? `contractEndDateFrom=${encodeURIComponent(
                        format(contractEndDateFrom, 'yyyy-MM-dd')
                      )}`
                      : '',
                  contractEndDateTo:
                    contractEndDateTo !== null && contractEndDateTo !== undefined
                      ? `contractEndDateTo=${encodeURIComponent(
                        format(contractEndDateTo, 'yyyy-MM-dd')
                      )}`
                      : '',
                  lastRiskAssessmentDateFrom:
                    lastRiskAssessmentDateFrom !== null && lastRiskAssessmentDateFrom !== undefined
                      ? `lastRiskAssessmentDateFrom=${encodeURIComponent(
                        format(lastRiskAssessmentDateFrom, 'yyyy-MM-dd')
                      )}`
                      : '',
                  lastRiskAssessmentDateTo:
                    lastRiskAssessmentDateTo !== null && lastRiskAssessmentDateTo !== undefined
                      ? `lastRiskAssessmentDateTo=${encodeURIComponent(
                        format(lastRiskAssessmentDateTo, 'yyyy-MM-dd')
                      )}`
                      : '',
                  includesPersonalData: returnMultiSelectString(
                    watch('includesPersonalData'),
                    'includesPersonalData'
                  ),
                  assessmentResults: returnMultiSelectString(
                    watch('assessmentResults'),
                    'assessmentResults'
                  ),
                }} />
            </div>
          </div>
        </div>
        </FormProvider>
    </div>
  );
};

export default ExternalizationsReport;